/** Request com os dados para dados para revisar as Análises de Mercado */
export class ClienteAnaliseMercadoRevisaoRevisarRequest {
    ano: number;
    idRepresentante: number;

    constructor(ano: number, idRepresentante: number) {
        this.ano = ano;
        this.idRepresentante = idRepresentante;
    }
}
